// DO NOT EDIT THIS DOCUMENT, BUILD TOOLING MANAGES THIS FILE
export const buildInfo = {
  buildUser: 'James Spivey <james@spivey.io>',
  buildDate: 'Fri Feb 21 2025 21:31:40 GMT+0000 (Coordinated Universal Time)',
  gitHash: '03dadea2bae136fafa3c16fb09001d45843f90db',
  appVersion: '0.0.1',
};
